<template>
  <TheGreyWrapper>
    <TheHeader back-route="/" />
    <BaseSection class="mb-4">
      <BaseTitleGroup
        :title="$t('Change your password')"
        subtitle="Kerala"
        class="mb-4"
      />
      <BaseWarningBox
        v-if="message"
        class="mb-4"
      >
        <span class="text-black font-heavy">{{ $t('Info') }}: </span>
        {{ $t(message) }}
      </BaseWarningBox>
      <form @submit.prevent="submit">
        <BaseInputGroup
          v-model="password"
          :label="$t('Password')"
          type="password"
          class="mb-4"
          autofocus
          required
        />
        <BaseButton
          :title="$t('Submit')"
          class="mb-6"
        />
      </form>
    </BaseSection>
  </TheGreyWrapper>
</template>

<script>
import { get } from 'lodash';
import TheHeader from '../components/TheHeader.vue';
import BaseSection from '../components/BaseSection.vue';
import BaseTitleGroup from '../components/BaseTitleGroup.vue';
import BaseInputGroup from '../components/BaseInputGroup.vue';
import BaseButton from '../components/BaseButton.vue';
import BaseWarningBox from '../components/BaseWarningBox.vue';
import TheGreyWrapper from '../components/TheGreyWrapper.vue';
import { SUBMIT_NEW_PASSWORD } from '../analytics';

export default {
  name: 'PasswordEdit',
  components: {
    TheHeader,
    BaseSection,
    BaseTitleGroup,
    BaseInputGroup,
    BaseButton,
    BaseWarningBox,
    TheGreyWrapper,
  },
  data() {
    return {
      message: null,
      password: null,
    };
  },
  computed: {
    token() {
      return this.$route.query.reset_password_token;
    },
  },
  methods: {
    submit() {
      analytics.track(SUBMIT_NEW_PASSWORD);
      this.$store.dispatch('auth/sendNewPassword', { password: this.password, token: this.token }).catch((error) => {
        if (error.response.status === 422) {
          if (get(error.response, 'data.errors.reset_password_token[0]') === "n'est pas valide") {
            this.message = 'Reset password token expired';
          } else {
            this.message = 'Invalid password';
          }
        }
      });
    },
  },
};
</script>
